__turbopack_context__.v({
  "image": "styles-module-scss-module__5Kbwsa__image",
  "info": "styles-module-scss-module__5Kbwsa__info",
  "info__date": "styles-module-scss-module__5Kbwsa__info__date",
  "info__paragraph": "styles-module-scss-module__5Kbwsa__info__paragraph",
  "info__title": "styles-module-scss-module__5Kbwsa__info__title",
  "link": "styles-module-scss-module__5Kbwsa__link",
  "outer": "styles-module-scss-module__5Kbwsa__outer",
});
